import React from 'react';
import styled from 'styled-components';
import { useTheme } from '../../contexts/ThemeContext';
import { Heading, Text } from '../components/Typography';
import { Divider } from '../components/Decorative';
import { Stack } from '../components/Layout';
import { spacing } from '../tokens/spacing';

interface FormSectionProps {
  title?: string;
  description?: string;
  children: React.ReactNode;
  divider?: boolean;
  spacing?: 'sm' | 'md' | 'lg';
  className?: string;
}

const SectionContainer = styled.div<{ spacing: 'sm' | 'md' | 'lg' }>`
  margin-bottom: ${props => {
    const spacings = {
      sm: spacing[4],
      md: spacing[6],
      lg: spacing[8],
    };
    return spacings[props.spacing];
  }};
`;

const HeadingWithMarginBottom = styled(Heading)`
  margin-bottom: ${spacing[2]};
`;

const SectionHeader = styled.div`
  margin-bottom: ${spacing[4]};
`;

export const FormSection: React.FC<FormSectionProps> = ({
  title,
  description,
  children,
  divider = false,
  spacing = 'md',
  className,
}) => {
  return (
    <SectionContainer spacing={spacing} className={className}>
      {(title || description) && (
        <SectionHeader>
          {title && (
            <HeadingWithMarginBottom variant="h3" color="text">
              {title}
            </HeadingWithMarginBottom>
          )}
          {description && (
            <Text color="secondary" size="sm">
              {description}
            </Text>
          )}
        </SectionHeader>
      )}
      {divider && <Divider spacing="md" />}
      <Stack direction="column" spacing="md">
        {children}
      </Stack>
    </SectionContainer>
  );
};

export default FormSection;
